import { Backdrop, Box, CircularProgress, Stack } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { Outlet } from "react-router-dom";
import { AppWaiting } from "share-components/app-waiting/app-waiting";
import { Header } from "./header/header";
import { Navigation } from "./navigation/navigation";
export const HomePage = observer(() => {
  const { inProgress, appFreeze } = useStores();

  return (
    <Stack direction={"column"} sx={{ height: "100vh", width: "100vw" }}>
      <Header></Header>
      <Box component="div" sx={{ minHeight: "2px" }}>
        {inProgress && (
          <Backdrop
            invisible={true}
            sx={{
              zIndex: 999999,
            }}
            open={true}
          >
            <Box
              sx={{
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress size={"30px"} />
            </Box>
          </Backdrop>
        )}
      </Box>
      <Stack
        flex={1}
        direction={"row"}
        minHeight={0}
        sx={{ marginTop: "10px" }}
      >
        <Navigation></Navigation>
        <Stack flex={1} component={"main"} sx={{ overflow: "auto" }}>
          <Outlet />
        </Stack>
      </Stack>

      {appFreeze && <AppWaiting></AppWaiting>}
    </Stack>
  );
});
